export default "__VITE_ASSET__CZL4YtKB__"